import script from "./SocialShare.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialShare.vue?vue&type=script&setup=true&lang=js"

import "./SocialShare.vue?vue&type=style&index=0&id=4f5b9aa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5b9aa6"]])

export default __exports__